import { Note, Project } from '../../../_service/data.service';
import { Router } from '@angular/router';
import { FilterParams } from '../../../_service/filter.service';

/**
 * Navigation logic extracted from HomeComponent.
 * Handles all router navigation and view transitions.
 */
export class NavigationLogic {
  /**
   * Navigate to edit a specific note
   */
  static navigateToEdit(router: Router, note: Note, filter: FilterParams): void {
    console.log(note);
    router.navigate(['edit', note._id], {
      state: { filter: filter },
    });
  }

  /**
   * Navigate to view a specific note
   */
  static clickRow(router: Router, note: Note, filter: FilterParams): void {
    console.log('clickRow() - Note: ', note.Title);
    router.navigate(['view', note._id], {
      state: { filter: filter },
    });
  }

  /**
   * Navigate to admin page
   */
  static goToAdmin(router: Router, filter: FilterParams): void {
    router.navigate(['admin'], { state: { filter: filter } });
  }

  /**
   * Navigate to user settings page
   */
  static goToUserSettings(router: Router, filter: FilterParams): void {
    router.navigate(['user-settings'], { state: { filter: filter } });
  }

  /**
   * Filter by project and navigate to list view
   */
  static clickCardHeader(router: Router, project: Project, filter: FilterParams): void {
    console.log('clickCardHeader() - Project: ', project.Name);
    const updatedFilter = { ...filter, ProjectName: project.Name };
    router.navigate(['/list'], {
      state: { filter: updatedFilter },
    });
  }

  /**
   * Logout and navigate to login page
   */
  static logout(router: Router, authService: any): void {
    authService.logout();
    router.navigate(['login']);
  }

  /**
   * Navigate to debug chroma page
   */
  static goToDebugChroma(router: Router): void {
    router.navigate(['/ai/administration']);
  }
}
